module.exports = __webpack_public_path__ + "static/werewolf-93ba49cbd51253bd85db62fc73d398c6.jpg";